import type { StateStore } from "../app/state/StateStore";

import { BaseBlock } from "./BaseBlock";

/**
 * Блок со ссылками на дополнительные материалы.
 */
export class NoticeLinksBlock extends BaseBlock {

    constructor(
        private readonly store: StateStore
    ) {
        super();
    }

    public override mount(): void {

        this.root = this.render();

    }

    public override update(): void {

        const newRoot = this.render();

        this.root.replaceWith(newRoot);

        this.root = newRoot;

    }

    private render(): HTMLElement {

        const wrapper =
            document.createElement("div");

        const state =
            this.store.getState();

        if (state.primaryScreen.type !== "notice") {
            return wrapper;
        }

        const data =
            state.primaryScreen.notice?.[0];

        if (!data?.links) {
            return wrapper;
        }

        const allItems: Array<{
            url: string;
            icon: string;
            platform: string;
        }> = [];

        Object.entries(
            data.links.video || {}
        ).forEach(([platform, item]: any) => {

            allItems.push({
                ...item,
                platform
            });

        });

        Object.entries(
            data.links.text || {}
        ).forEach(([platform, item]: any) => {

            allItems.push({
                ...item,
                platform
            });

        });

        if (!allItems.length) {
            return wrapper;
        }

        wrapper.className =
            "notice-grid";

        for (const item of allItems) {

            const card =
                document.createElement("a");

            card.href =
                item.url;

            card.target =
                "_blank";

            card.className =
                `notice-card notice-${item.platform}`;

            const image =
                document.createElement("img");

            image.src =
                item.icon;

            image.className =
                "notice-card-img";

            card.appendChild(
                image
            );

            const badge =
                document.createElement("div");

            badge.className =
                "notice-badge";

            const badgeIcon =
                document.createElement("img");

            switch (item.platform) {

                case "instagram":
                    badgeIcon.src = "/icons/instagram.png";
                    break;

                case "facebook":
                    badgeIcon.src = "/icons/facebook.png";
                    break;

                case "youtube":
                    badgeIcon.src = "/icons/youtube.png";
                    break;

                case "tiktok":
                    badgeIcon.src = "/icons/tiktok.png";
                    break;

            }

            badgeIcon.className =
                "notice-badge-icon";

            badge.appendChild(
                badgeIcon
            );

            card.appendChild(
                badge
            );

            wrapper.appendChild(
                card
            );

        }

        if (allItems.length === 1) {

            wrapper.style.display =
                "flex";

            wrapper.style.justifyContent =
                "center";

        }

        return wrapper;

    }

}